import { Formatters, Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { SchedulingErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { FlowContentType } from '../models/ContentTypes';
import { IErrorItem } from '../models/MultipleItemResult';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { ContentUrlForItem } from './ContentUrl';
import { actionSuccessTranslation, actionErrorTranslation } from './ContentActionNotification';

export class ResumeRunFlowTasksAction {

  public static $inject = [
      'ConfirmActionDialog',
      'RunFlowTasks'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private RunFlowTasks: RunFlowTasks
  ) { }

  public executeWithContext(runFlowTaskInfos: Set<RunFlowTaskInfo>, context: IActionContext): ng.IPromise<IResult> {
    const description: string = Messages.runFlowTasksConfirmResume({
      TASK_COUNT: runFlowTaskInfos.size(),
      TASK_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size()),
    });


    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: Messages.runFlowTasksResume(),
      bodyText: description,
      actionName: Messages.runFlowTasksResume(),

      action: () => {
        return this.RunFlowTasks.resume(runFlowTaskInfos.keys())
          .then(result => ActionHelpers.notifyStandardError(
            runFlowTaskInfos,
            result,
            {
              success: actionSuccessTranslation(Messages.runFlowTasksResumeSuccess),
              error: actionErrorTranslation(Messages.runFlowTasksResumeError),
            },
            (errorItem: IErrorItem<RunFlowTaskInfo>) => {
              const namedItem: INamedItemInfo = errorItem.item.flow;
              return {
                itemName: namedItem.name,
                itemUrl: this.urlFor(errorItem),
                errorMessage: this.errorMessageFor(errorItem)
              };
            }
          ));
      }
    }).result;
  }

  private urlFor(errorItem: IErrorItem<RunFlowTaskInfo>): string {
    return ContentUrlForItem(errorItem.item.flow, FlowContentType);
  }

  private errorMessageFor(errorItem: IErrorItem<RunFlowTaskInfo>) {
    switch (errorItem.error.code) {
      case SchedulingErrorCode.SchedulingTaskNotFound:
        return Messages.errorRunFlowTaskNotFound({
          FLOW_NAME: L10n.elideIfLong(errorItem.item.flow.name),
          SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
        });
      default:
        return Messages.errorUnknown();
    }
  }

}

Module.instance().service('ResumeRunFlowTasksAction', ResumeRunFlowTasksAction);
